import { twMerge } from "tailwind-merge";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={twMerge(
        "motion-safe:animate-pulse rounded-md bg-backgroundSkeleton",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
